import { Box } from '@mui/material';

import { getPropertiesTooltip } from '../model/lib/propertiesDisplay';

import type { ProductMetricsDto } from 'entities/ReportSavingsSummary';
import type { ReportWidgetItem } from 'widgets/ComposableReportWidget';

interface PropertiesTooltipProps {
    item: ReportWidgetItem;
}

interface PropertiesMeta {
    productMetrics?: ProductMetricsDto;
}

export const PropertiesTooltip = ({ item }: PropertiesTooltipProps) => {
    const meta = (item.meta as PropertiesMeta | undefined) ?? {};
    const dto = meta.productMetrics;

    if (!dto) {
        return null;
    }

    const content = getPropertiesTooltip(dto);

    if (!content) {
        return null;
    }

    return (
        <Box
            sx={{
                maxHeight: 260,
                overflowY: 'auto',
                whiteSpace: 'pre-wrap',
                paddingRight: 0.5,
            }}
        >
            {content}
        </Box>
    );
};
